































import { Component, Prop, Vue } from "vue-property-decorator";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { CreateCard } from "@/api/lab-base-api-client";
import AuthModule from "@/store/auth";
import StripeApi from "@/services/StripeApi";
import { loadStripe, StripeCardNumberElement } from "@stripe/stripe-js";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class PaymentForm extends Vue {
  // 入力フォーム初期値
  private form: CreateCard | { cusId: string; number: null; exp_month: null; exp_year: null; cvc: null } = {
    cusId: "",
    number: null,
    // eslint-disable-next-line @typescript-eslint/camelcase
    exp_month: null,
    // eslint-disable-next-line @typescript-eslint/camelcase
    exp_year: null,
    cvc: null,
  };

  @Prop({ type: String, required: true })
  cusId: string | undefined;

  private get me() {
    return AuthModule.me;
  }

  private get STRIPE_PUBLISHABLE_KEY() {
    return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private mounted() {
    this.stripe();
  }

  private async stripe() {
    const stripe = await loadStripe(this.STRIPE_PUBLISHABLE_KEY as string);

    if (!stripe) {
      logger.frontError("failed load stripe");
      throw new Error("Failed load stripe");
    }

    const elements = stripe?.elements();

    const elementStyles = {
      base: {
        color: "#000000",
        fontFamily: "Yu Gothic, YuGothic",
        fontSize: "16px",
        fontWeight: "bold",

        "::placeholder": {
          color: "#c0c0c0",
        },

        ":focus::placeholder": {
          color: "#c0c0c0",
        },
      },
      invalid: {
        color: "red",
        ":focus": {
          color: "#E83A3B",
        },
        "::placeholder": {
          color: "#E83A3B",
        },
      },
    };

    const elementClasses = {
      focus: "focus",
      empty: "empty",
      invalid: "invalid",
      complete: "complete",
    };

    const cardNumber = elements?.create("cardNumber", {
      style: elementStyles,
      classes: elementClasses,
    });

    // eslint-disable-next-line no-unused-expressions
    cardNumber?.mount("#cardNumber");

    const cardExpiry = elements?.create("cardExpiry", {
      style: elementStyles,
      classes: elementClasses,
    });

    // eslint-disable-next-line no-unused-expressions
    cardExpiry?.mount("#cardExpiry");

    const cardCvc = elements?.create("cardCvc", {
      style: elementStyles,
      classes: elementClasses,
    });

    // eslint-disable-next-line no-unused-expressions
    cardNumber?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardNumberErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      }
    });
    // eslint-disable-next-line no-unused-expressions
    cardExpiry?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardExpiryErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      }
    });
    // eslint-disable-next-line no-unused-expressions
    cardCvc?.on("change", ({ error }) => {
      const displayError = document.getElementById("cardCvcErrors");
      if (displayError) {
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      }
    });
    // eslint-disable-next-line no-unused-expressions
    cardCvc?.mount("#cardCvc");

    const form = document.getElementById("paymentForm");

    if (form) {
      form.addEventListener("submit", event => {
        event.preventDefault();
        if (this.cusId) {
          this.form.cusId = this.cusId;
        }
        const cardElement = elements.getElement("cardNumber") as StripeCardNumberElement;
        stripe
          .createPaymentMethod({
            type: "card",
            card: cardElement,
            // eslint-disable-next-line @typescript-eslint/camelcase
            billing_details: {
              name: this.me?.userDetail.fullName,
            },
          })
          .then(async result => {
            if (result.error) {
              console.log("err", result.error);
              TooltipModule.commitIsShow(true);
              setTimeout(() => {
                TooltipModule.commitIsShow(false);
              }, 5000);
            } else {
              const paymentMethodId = result.paymentMethod.id;
              const cusId = (await this.me?.cusId) as string;

              // 新規カード登録
              try {
                await StripeApi.instance.postUpdatePaymentMethods({ cusId, paymentMethodId });
                this.$router.push({ name: "URegisterPayment" });
              } catch (err) {
                TooltipModule.commitIsShow(true);
                setTimeout(() => {
                  TooltipModule.commitIsShow(false);
                }, 5000);
                if (err instanceof Error) {
                  logger.frontError(`${err.name}: ${err.message}`);
                  console.log(err);
                }
              }
            }
          });
      });
    }
  }
}
